import { render, staticRenderFns } from "./LinksObjects.vue?vue&type=template&id=6a8284b4&scoped=true&"
import script from "./LinksObjects.vue?vue&type=script&lang=js&"
export * from "./LinksObjects.vue?vue&type=script&lang=js&"
import style0 from "./LinksObjects.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./LinksObjects.vue?vue&type=style&index=1&id=6a8284b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8284b4",
  null
  
)

export default component.exports